'use client';

import { useState } from 'react';

import type { OrderDocument } from '@eliadmin/core/src/api/customers/customers-types';
import { downloadFileFromBlob } from '@eliadmin/core/src/api/general/general-api';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

/**
 * „Faktúra (PDF)“: the order's first document, downloaded like `OrderDocumentButton` of the
 * confirmation. The core download needs the customer's token, so there is no document for a guest –
 * nor for an order the shop has not issued one for yet.
 */
export function useOrderDocument(documents: Pick<OrderDocument, 'id' | 'name' | 'number'>[]) {
  const authToken = useCustomerStore(s => s.me?.authToken);
  const locale = useLocaleStore(s => s.currentLocale);
  const [loading, setLoading] = useState(false);
  const document = authToken ? documents[0] : undefined;

  const download = async () => {
    if (!document || !authToken) return;
    setLoading(true);
    try {
      await downloadFileFromBlob({
        fileId: document.id,
        authToken,
        locale,
        fileName: `${document.name}_${document.number}`,
      });
    } finally {
      setLoading(false);
    }
  };

  return { document, download, loading };
}
